












































































































































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import Loading from '@/app/components/Common/Loading.vue'
import SpFieldImg from '@/app/components/SpField/SpFieldImg.vue'
import SpHeader from '@/app/components/Common/SpHeader.vue'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import DateClass from '@/app/module/date'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import plant from './Plant.vue'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
/* api */
import PlantingRecordsApi from '@/app/model/api/plantingRecordsApi'
import FieldListApi from '@/app/model/api/fieldListApi'

@Component({
  components: {
    Loading,
    SpFieldImg,
    SpHeader,
    Datepicker
  }
})
export default class SpFieldDetails extends Vue {
  /* 表示切り替え */
  private showLoading: boolean = true
  private showPlantingDetails: boolean = true
  private isActive: boolean = false
  private notFoundMessage: string = ''
  /* データ */
  private viewHeight:number = 100
  private otherListHeight: number = 0
  private plantDetailData: any = {}
  private plantingRecords: any = {}
  private stageMemori: string[] = ['1', '3', '4', '5', '6', '7', '8', '9', '10', '11']
  // 検索項目
  private displayContent: string = 'plantDetail'
  private changeContents: any = [
    { text: '作付け情報', value: 'plantDetail' },
    { text: '生育記録一覧', value: 'varietyList' }
  ]
  private searchDate: any = null

  private get tabChange (): any {
    return this.displayContent
  }
  /* datepicker */
  private japanese: Array<{[key:string]: string|boolean}> = ja
  private form: string = 'yyyy-MM-dd'

  @Watch('tabChange')
  getTabChange (tabName: string) {
    if (tabName === 'plantDetail') {
      this.showPlantingDetails = true
    } else {
      this.showPlantingDetails = false
    }

    this.getOtherListHeight()
  }

  created () {
    this.getFieldData()
    // 生育記録詳細・登録・編集
    if (this.$store.state.spFieldState.beforeRecordDate !== 0) {
      this.displayContent = 'varietyList'
    }
    this.getPlantingRecords()
  }

  mounted () {
    this.viewHeight = window.innerHeight

    let el: any = document.getElementById('listArea')
    el.addEventListener('scroll', this.handleScroll)
  }

  private getOtherListHeight () {
    let topWrap: any = document.getElementById('topWrap')
    if (topWrap !== null) {
      this.$nextTick(function () {
        this.otherListHeight = topWrap.clientHeight + 60
      })
    }
  }

  /* データ取得 */
  private async getFieldData () {
    const data = {
      order_num: 2,
      word: '',
      variety_id: 0,
      grade_id: 0,
      growth_stage_id: 0,
      risk_id: 0,
      planting_id: parseInt(this.$route.params.plant_id),
      is_polygon: 1,
      is_field: 1
    }

    const result = await FieldListApi.getFieldData(this.$store.state.fieldState.plantingOnly, '1', data)

    if (result.isOk()) {
      if (result.getPayload().field_list.length === 0) {
        this.error404()
      } else {
        if (result.getPayload().field_list[0].field_id === parseInt(this.$route.params.field_id)) {
          this.plantDetailData = result.getPayload().field_list[0]
          this.getOtherListHeight()
        } else {
          this.error404()
        }
      }
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'sp', 'GET', 'alert')
    }
    if (this.displayContent === 'plantDetail') {
      this.showLoading = false
    }
  }

  private getImage (images: any) {
    let targetImage = {
      crop_image_id: null
    }
    for (const key in images) {
      if (images[key].display_number === 1) {
        targetImage.crop_image_id = images[key].crop_image_id
        break
      }
    }
    return targetImage
  }

  private error404 () {
    // notFound(404ページへ遷移)
    this.$store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_DEFAULT)
    this.$router.push(routerPath.PATH_SP_ERROR_PAGE).catch(e => {})
  }

  private scTimer: number = 0
  private scY: number = 0

  private handleScroll () {
    const el: any = document.getElementById('listArea')
    if (this.scTimer) {
      return
    }
    this.scTimer = setTimeout(() => {
      this.scY = el.scrollTop
      clearTimeout(this.scTimer)
      this.scTimer = 0
    }, 100)
  }

  public active () {
    if (this.isActive) {
      this.isActive = false
    } else {
      this.isActive = true
    }

    this.getOtherListHeight()
  }

  private getStageNum (stageName: string) {
    if (stageName === undefined) {
      return null
    } else {
      let num = stageName.split('.', 1)
      return this.stageMemori.indexOf(num[0]) + 1
    }
  }

  private scrollToRecordDate () {
    if (this.searchDate === null) {
      this.notFoundMessage = '検索する記録日を指定してください。'
      return
    }
    const formingDate = DateClass.toDoubleDigits(this.searchDate.getFullYear()) + '' + DateClass.toDoubleDigits(this.searchDate.getMonth() + 1) + '' + DateClass.toDoubleDigits(this.searchDate.getDate())
    const id = 'recordDate' + formingDate
    let el: any = document.getElementById(id)

    if (el !== null) {
      this.notFoundMessage = ''
      el.scrollIntoView({ behavior: 'instant' })
    } else {
      this.notFoundMessage = '条件に一致する生育記録は見つかりませんでした。'
    }
  }

  private scrollTop () {
    const id = 'recordDate' + this.dateToNumberYmd(this.plantingRecords[0].record_date)
    let el: any = document.getElementById(id)
    el.scrollIntoView({ behavior: 'instant' })
  }

  private showRecodeDate () {
    const id = 'recordDate' + this.$store.state.spFieldState.beforeRecordDate
    let el: any = document.getElementById(id)
    if (el === null) {
      setTimeout(this.showRecodeDate, 200)
    } else {
      el.scrollIntoView({ behavior: 'instant' })
      this.$store.commit('spFieldState/setBeforeRecordDate', 0)
    }
  }

  private getPlantingRecords () {
    (async () => {
      const result = await PlantingRecordsApi.getPlantingRecords(this.$route.params.plant_id)
      if (result.isOk()) {
        this.plantingRecords = result.getPayload().results
        if (this.$store.state.spFieldState.beforeRecordDate !== 0) {
          this.showRecodeDate()
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'sp', 'GET', 'alert')
      }
      if (this.displayContent === 'varietyList') {
        this.showLoading = false
      }
    })()
  }

  private toCreateRecord () {
    this.$router.push('/sp/field/' + this.$route.params.field_id + '/' + this.$route.params.plant_id + '/record/create').catch(e => {})
  }

  private toRecordDetail (date: any) {
    const updateDate = new Date(date.replace(/-/g, '/'))
    const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '' + DateClass.toDoubleDigits(updateDate.getDate())
    this.$router.push('/sp/field/' + this.$route.params.field_id + '/' + this.$route.params.plant_id + '/record/' + formingDate).catch(e => {})
  }

  private dateToNumberYmd (date: any) {
    if (date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '' + DateClass.toDoubleDigits(updateDate.getDate())
      return parseInt(formingDate)
    }
  }

  private dateToStringYmd (date: any) {
    if (date !== '' && date !== undefined) {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '年' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '月' + DateClass.toDoubleDigits(updateDate.getDate()) + '日'
      return formingDate
    }
  }

  private displayPlantingType (type: number) {
    return CommonClass.displayPlantingType(type)
  }
}
